export enum AppRoutes {
  /**
   * //////////////////////////////////////////////////////
   * ROUTES WITHOUT ACTIVE USER
   * //////////////////////////////////////////////////////
   */

  /**
   * Landing Page
   */
  socialHome = 'https://socialmirror.ai',

  /**
   * Public Form
   */
  revealDigitalFootprint = '/reveal-digital-footprint',
  prospectEmailVerification = '/verification',
  publicPaymentPaywall = '/plans',

  /**
   * Login - Main Login Routes
   */
  forgotPaswordCheckYourInbox = '/forgot-pasword-check-your-inbox',
  login = '/login',
  forgotPassword = '/forgot-password',
  createPassword = '/create-password',
  loginError = '/login/error',

  /**
   * Auth Success Route - SSO callback
   */
  authSuccess = '/auth/success',

  /**
   * Set Password Route - Payment Link flow
   */
  setPassword = '/sign-up/set-password',

  /**
   * SignUp - Main Login Routes & Onboarding
   */
  registerStart = '/sign-up/get-started',
  registerEmailVerification = '/sign-up/OTP-email',
  registerPhoneNumber = '/sign-up/phone',
  registerPhoneVerification = '/sign-up/OTP-phone',
  welcomeToSelfCheck = '/sign-up/welcome',
  motivation = '/sign-up/motivation',
  signUpContactUs = '/sign-up/contact-us',
  personalInfo = '/sign-up/personal-info',

  /**
   * Setup
   */
  setupDigitalFootprint = '/setup/digital-footprint',
  defaultBehaviorAndTopics = '/setup/flags',

  /**
   * KYC
   */
  kycVerification = '/kyc/start-verification',
  kycVerificationInProgress = '/kyc/verification-in-progress',
  kycVerificationSuccess = '/kyc/verification-success',
  kycVerificationFailed = '/kyc/verification-failed',

  /**
   * //////////////////////////////////////////////////////
   * ROUTES FOR ACTIVE USERS
   * //////////////////////////////////////////////////////
   */

  /**
   * Payment
   */
  generatingReportMock = '/preparing-report',
  paymentPaywall = '/paywall',
  paymentSuccess = '/payment-success',

  /**
   * Stripe Payment Redirect - callback from payment link
   */
  stripePaymentRedirect = '/stripe/payment-redirect',

  /**
   * Report
   */
  socialMediaProfile = '/report/social-media-profile',
  digitalReport = '/report/digital-report',

  /**
   * Dashboard
   */
  dashboard = '/dashboard/home',
  contactUs = '/dashboard/contact-us',
  billingAndInvoices = '/dashboard/billing-and-invoices',
  reports = '/dashboard/reports',
  account = '/dashboard/settings',
  settingsVerifyPhone = '/dashboard/settings/verify-phone',
  settingsVerifyPhoneOTP = '/dashboard/settings/verify-phone/otp',

  /**
   * Search
   */
  confirmSearchInfo = '/search/confirm-info',
  editDigitalFootprint = '/search/edit-profile',
  generatingReport = '/search/generating-report',

  /**
   * Impersonation Check
   */
  impersonationConfirmInfo = '/impersonation/confirm-info',
  impersonationScreening = '/impersonation/screening',
  impersonationPaywall = '/impersonation/paywall',
  impersonationPaymentSuccess = '/impersonation/payment-success',
  impersonationGeneratingReport = '/impersonation/generating-report',
  impersonationReport = '/impersonation/report',
}
